<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="attributeSales"
      :model="model"
      :required-date-value="$parent.dateRange"
      :use-action="false"
      :use-default-action="false"
      entity-name="AttributeStatistik"
    >
      <template #primaryButton>
        <v-btn
          color="amber lighten-4 black--text"
          elevation="0"
          @click="download"
        >
          <v-icon left>
            mdi-export
          </v-icon>
          {{ $t('export') }}
        </v-btn>
      </template>
    </ik-data-table>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import AttributeStatistics from '@/model/dataLayer/api/bills/AttributeStatistics'
import FileSaver from 'file-saver'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return {
      loading: false,

      model: AttributeStatistics
    }
  },
  computed: {
    realFilter () {
      return {
        dateFilter: this.$parent.dateRange
      }
    }
  },
  watch: {
    '$parent.dateRange': {
      handler: function (val) {
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async download () {
      const data = this.$refs.attributeSales.items
      let dataStrings = ['时间,属性名,数量,单价,共计']
      data.forEach(it => {
        const res = [this.$parent.dateRange.join('~'), it.currentName, it.amount, it.price, it.totalPrice]
        dataStrings.push(res.join())
      })
      dataStrings = dataStrings.join('\n')
      const blob = new Blob([dataStrings], { type: 'text/plain;charset=utf-8' })
      FileSaver.saveAs(blob, 'Attribute Statistics.csv')
    }
  }
}
</script>

<style scoped>

</style>
